'use client';

import NoData from '~/shared/components/no-data';
import type { useTypedTranslation } from '~/shared/hooks';
import type { Locale } from '~/universal/constants';

import type { PopularArticleMenuItem } from '../blog-menu/helpers/blog-menu-cache';
import PopularArticleItem from '../popular-article-item';

import './popular-articles.scss';

type PopularArticleListItem =
  | PopularArticleMenuItem
  | Readonly<{
      _id: string;
      item: null;
    }>;

type PopularArticlesProps = Readonly<{
  lng: Locale;
  error: boolean;
  loading: boolean;
  items: PopularArticleListItem[];
  t: ReturnType<typeof useTypedTranslation>;
}>;

const PopularArticles = ({ lng, items, closeDropdown, t, error, loading }: PopularArticlesProps) => {
  return (
    <nav itemScope itemType="https://schema.org/SiteNavigationElement" className="popular-articles">
      <div className="popular-articles__title">{t('text.popular-articles')}:</div>

      <div className="popular-articles__list">
        {items.length > 0 ? (
          <ul className="top-rated-categories__list">
            {items.map(({ _id, item }) => (
              <PopularArticleItem
                closeDropdown={closeDropdown}
                key={_id}
                lng={lng}
                error={error}
                loading={loading}
                item={item}
              />
            ))}
          </ul>
        ) : (
          <NoData variant="web" t={t} />
        )}
      </div>
    </nav>
  );
};

export default PopularArticles;
